import type { GameFeedback } from "./engine/types";

// Vibration patterns (ms on, off, on...) for game moments. Short and light for
// the constant ones, longer for the moments that should be felt. Phones
// without the Vibration API (every iPhone browser) simply do nothing.
const PATTERNS: Record<GameFeedback, number | number[]> = {
  tap: 8,
  score: 14,
  hurt: [35, 40, 35],
  crash: [90, 40, 60],
  level: [18, 50, 18],
  boss: [60, 60, 60, 60, 140],
  win: [25, 35, 25, 35, 90],
};

// Stronger moments win when several land in one frame.
const RANK: GameFeedback[] = ["tap", "score", "level", "hurt", "win", "boss", "crash"];
const MIN_GAP_MS = 70;

export const canVibrate = () => typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

export function createHaptics() {
  let lastAt = -Infinity;
  let busyUntil = 0;
  return {
    play(events: GameFeedback[], nowMs: number) {
      if (events.length === 0 || !canVibrate()) return;
      let strongest = events[0];
      for (const event of events) if (RANK.indexOf(event) > RANK.indexOf(strongest)) strongest = event;
      // Taps never cut into a longer pattern that is still playing.
      if (strongest === "tap" && nowMs < busyUntil) return;
      if (nowMs - lastAt < MIN_GAP_MS && strongest === "tap") return;
      const pattern = PATTERNS[strongest];
      lastAt = nowMs;
      busyUntil = nowMs + (Array.isArray(pattern) ? pattern.reduce((sum, ms) => sum + ms, 0) : pattern);
      try {
        navigator.vibrate(pattern);
      } catch {
        // Some browsers throw when the page is not user activated yet.
      }
    },
    stop() {
      if (canVibrate()) {
        try {
          navigator.vibrate(0);
        } catch {
          // Nothing to stop.
        }
      }
    },
  };
}
